import { Team__Adrianes } from "../teams/Adrianes";
import { Team__Cerveceros_2 } from "../teams/Cerveceros_2";
import { Team__Joeles } from "../teams/Joeles";
import { Team__Llamas } from "../teams/Llamas";
import { Team__Lorenas } from "../teams/Lorenas";
import { Team__LosQuintanas } from "../teams/LosQuintanas";
import { Team__Natalias } from "../teams/Natalias";
import { Team__PecanBros } from "../teams/PecanBros";
import { Team__Potros } from "../teams/Potros";
import { Team__Pythons } from "../teams/Pythons";
import { Team__RoadRunner } from "../teams/RoadRunner";
import { Team__RWE } from "../teams/RWE";
import { Team__Wolfpack } from "../teams/Wolfpack";

const Adrianes = {
  team: Team__Adrianes,
  playingPlayers: [],

  goals: 0,
  penaltyGoals: 0,
  isWinner: false,
};

const Cerveceros = {
  team: Team__Cerveceros_2,
  playingPlayers: [],

  goals: 29,
  penaltyGoals: 0,
  isWinner: false,
};

const Natalias = {
  team: Team__Natalias,
  playingPlayers: [],

  goals: 0,
  penaltyGoals: 0,
  isWinner: false,
};

const Joeles = {
  team: Team__Joeles,
  playingPlayers: [],

  goals: 0,
  penaltyGoals: 0,
  isWinner: false,
};

const Llamas = {
  team: Team__Llamas,
  playingPlayers: [],

  goals: 0,
  penaltyGoals: 0,
  isWinner: false,
};

const Lorenas = {
  team: Team__Lorenas,
  playingPlayers: [],

  goals: 0,
  penaltyGoals: 0,
  isWinner: false,
};

const LosQuintanas = {
  team: Team__LosQuintanas,
  playingPlayers: [],

  goals: 0,
  penaltyGoals: 0,
  isWinner: false,
};

const PecanBros = {
  team: Team__PecanBros,
  playingPlayers: [],

  goals: 0,
  penaltyGoals: 0,
  isWinner: false,
};

const Potros = {
  team: Team__Potros,
  playingPlayers: [],

  goals: 46,
  penaltyGoals: 0,
  isWinner: false,
};

const Pythons = {
  team: Team__Pythons,
  playingPlayers: [],

  goals: 36,
  penaltyGoals: 0,
  isWinner: false,
};

const RoadRunner = {
  team: Team__RoadRunner,
  playingPlayers: [],

  goals: 0,
  penaltyGoals: 0,
  isWinner: false,
};

const RWE = {
  team: Team__RWE,
  playingPlayers: [],

  goals: 23,
  penaltyGoals: 0,
  isWinner: false,
};

const Wolfpack = {
  team: Team__Wolfpack,
  playingPlayers: [],

  goals: 0,
  penaltyGoals: 0,
  isWinner: false,
};

export const Jornada3 = {
  jornadaPosition: 3,
  matches: [
    {
      team1: Potros,
      team2: Cerveceros,

      isCompleted: true,
      isPlaying: true,
      day: "Miercoles",
      date: "2025-07-30",
      time: "13:00:00",
      location: "Centro Recreativo Lebaron",
    },
    {
      team1: RWE,
      team2: Pythons,

      isCompleted: true,
      isPlaying: true,
      day: "Miercoles",
      date: "2025-07-30",
      time: "14:00:00",
      location: "Centro Recreativo Lebaron",
    },
  ],
};
